function customFilter() {
  $(".loadMore__button.loadMore__button--products.btn.btn-secondary.js-loadMore__button--products")
    .text(translation("dalsiProdukty"));

  $(".extended-description h3")
    .text(translation("parametryProduktu"));

  $(".category-top")
    .append($(".poradit").clone().addClass("cloned"));

  loadBlogData();

  $("#productsTopHeading")
    .text(translation("nejprodavanejsiVKategorii"));

  if (!$("#filters > .h2").length) {
    $("#filters")
      .prepend(`
        <div class="h2">${translation("filtrovat")}</div>
        <button
          class="CloseFilters closeTop"
          type="button"
          title="${translation("filtrovat")}">
        </button>
      `)
      .append(`
        <div class="bottomFilterButton">
          <button
            class="CloseFilters closeBottom btn-conversion btn btn-primary"
            type="button"
            title="${translation("filtrovat")}">
            ${translation("filtrovat")}
          </button>
        </div>
      `);
  }

  $(".CloseFilters")
    .off("click")
    .on("click", function () {
      $("#filters").removeClass("visible");
      $("body").removeClass("filters-visible");
    });

  $("#filters")
    .off("click")
    .on("click", function () {
      $("#filters").toggleClass("visible");
    });

  $(".filters-unveil-button-wrapper a")
    .text(translation("filtrovat"))
    .attr("data-text", translation("zavritFiltr"));

  if (!$("body").hasClass("filters-visible")) {
    $("#filters").removeClass("visible");
  }

  $("#filters .filter-sections")
    .append($("#filters .slider-wrapper"));

  $(".slider-wrapper")
    .addClass("filter-section");

  if (!$(".filter-section-boolean .param-filter-top > h4").length) {
    $(".filter-section-boolean .param-filter-top")
      .addClass("filter-section")
      .prepend(`
        <h4>
          <span>${translation("dostupnost")}</span>
        </h4>
      `)
      .prependTo("#category-filter-hover");
  }
}

function customCategory() {
  $(".param-filter-top h4")
    .text(translation("stitky"));

  var $productsTop = $("#productsTop");

  if (!$productsTop.length || !$productsTop.children().length) {
    return;
  }

  if (!$productsTop.hasClass("slick-initialized")) {
    $productsTop.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,

      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });

    if ($(".slick-slider:not(.reviews .slick-slider)").length) {
      $(".slick-slider:not(.reviews .slick-slider)").each(function () {
        $(this).find(".arrowWrapper").remove();

        var $wrapper = $('<div class="arrowWrapper"></div>');

        $(this).find(".slick-dots").after($wrapper);

        var $arrows = $(this).find(".slick-arrow");

        if ($arrows.length) {
          $arrows.each(function () {
            var $arrow = $(this);
            $arrow.appendTo($wrapper);
          });
        }
      });
    }
  }
}

function customSorting() {
  if (!$(".category-content-wrapper > .customWrap").length) {
    $(".category-content-wrapper").prepend(`
      <div class="customWrap">
        <span class="customSorting btn btn-primary">
          ${translation("seraditDle")}
        </span>
      </div>
    `);
  }
}

$("html").on("click", ".customSorting", function () {
  $("#category-header").toggleClass("show");
  $(this).toggleClass("active");
});

function initFilterHint() {
  customFilter();
  customSorting();
  customCategory();
}

if ($(".type-category").length) {
  $("#filters").removeClass("visible");

  $("html")
    .off("click.customFilterClose", ".filters .CloseFilters")
    .on("click.customFilterClose", ".filters .CloseFilters", function () {
      $(".filters-unveil-button-wrapper a").trigger("click");
      $(".filters-unveil-button-wrapper a")
        .text(translation("filtrovat"))
        .attr("data-text", translation("zavritFiltr"));
    });

  $(document).ready(initFilterHint);

  document.addEventListener(
    "ShoptetDOMPageContentLoaded",
    initFilterHint
  );

  document.addEventListener(
    "ShoptetPageSortingChanged",
    initFilterHint
  );

  document.addEventListener(
    "ShoptetDOMPageMoreProductsLoaded",
    initFilterHint
  );

  document.addEventListener(
    "ShoptetDOMContentLoaded",
    initFilterHint
  );
}